<template>
  <v-sheet color="white" class="my-3 rounded-lg shadow">
    <v-container ref="bp_container" fluid fill-width class="ma-0 pa-0">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <div
            v-if="!visibleCohorts || visibleCohorts.length == 0"
            class="display-1 primary--text text--lighten-5 pt-5 mt-5"
            align="center"
          >
            NO STUDY GROUPS SELECTED
          </div>

          <div
            v-else-if="visibleCohorts.length < 2"
            class="display-1 primary--text text--lighten-5 pt-5 mt-5"
            align="center"
          >
            LESS THAN TWO STUDY GROUPS SELECTED
          </div>

          <v-container v-else fluid fill-height class="ma-0 pa-0 ml-2">
            <v-row class="ma-2 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                  <div style="display: flex;">
                    <v-toolbar-title
                      class="primary--text subtitle-1 font-weight-bold mb-1"
                      >Comparing</v-toolbar-title
                    >

                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ on: tooltip }">
                        <img
                          :src="
                            '/images/' + variable.category + '-icon-128.png'
                          "
                          :title="variable.category"
                          style="height:1.25em"
                          class="ma-1 ml-2"
                          @error="missingDomainFallback"
                          v-on="{ ...tooltip }"
                        />
                      </template>
                      <span>{{ variable.category }}</span>
                    </v-tooltip>

                    <v-tooltip top color="primary">
                      <template v-slot:activator="{ on: tooltip }">
                        <span
                          class="black--text subtitle-1 mb-1"
                          v-on="{ ...tooltip }"
                        >
                          {{ variable.label }}
                        </span>
                      </template>
                      <span>{{ variable.description }}</span>
                    </v-tooltip>

                    <v-toolbar-title
                      class="primary--text subtitle-1 font-weight-bold mb-1 ml-1"
                      >likelihood between:</v-toolbar-title
                    >
                  </div>
                </v-row>

                <v-row class="ma-0 pa-0">
                  <div class="ma-0 pa-0" style="display: flex;" align="center">
                    <!-- Note: Keep `item-text` dummy field. This fixes bug where item and selection props make all list items to appear as selected. -->
                    <v-select
                      v-model="targetCohort"
                      :items="visibleCohorts"
                      label="Target Study Group"
                      item-text="label"
                      style="width: 50%;"
                      return-object
                    >
                      <template v-slot:item="props">
                        <svg width="50" height="20">
                          <g>
                            <rect
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="props.item['color']"
                              stroke="black"
                            />
                            <rect
                              v-if="props.item['pattern'] != null"
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="
                                'url(#' + props.item['pattern']['id'] + ')'
                              "
                            />
                          </g>
                        </svg>
                        <span class="black--text text-body-1 ma-0 pa-0 ml-2">
                          {{ props.item.label.replace(/^\[O\]_/, '') }}
                        </span>
                      </template>

                      <template v-slot:selection="props">
                        <svg width="50" height="20">
                          <g>
                            <rect
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="props.item['color']"
                              stroke="black"
                            />
                            <rect
                              v-if="props.item['pattern'] != null"
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="
                                'url(#' + props.item['pattern']['id'] + ')'
                              "
                            />
                          </g>
                        </svg>
                        <span class="black--text text-body-1 ma-0 pa-0 ml-2">
                          {{ props.item.label.replace(/^\[O\]_/, '') }}
                        </span>
                      </template>
                    </v-select>

                    <v-select
                      v-model="controlCohort"
                      :items="visibleCohorts"
                      label="Control Study Group"
                      item-text="label"
                      class="ml-4"
                      style="width: 50%;"
                      return-object
                    >
                      <template v-slot:item="props">
                        <svg width="50" height="20">
                          <g>
                            <rect
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="props.item['color']"
                              stroke="black"
                            />
                            <rect
                              v-if="props.item['pattern'] != null"
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="
                                'url(#' + props.item['pattern']['id'] + ')'
                              "
                            />
                          </g>
                        </svg>
                        <span class="black--text text-body-1 ma-0 pa-0 ml-2">
                          {{ props.item.label.replace(/^\[O\]_/, '') }}
                        </span>
                      </template>

                      <template v-slot:selection="props">
                        <svg width="50" height="20">
                          <g>
                            <rect
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="props.item['color']"
                              stroke="black"
                            />
                            <rect
                              v-if="props.item['pattern'] != null"
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              border-radius="0%"
                              width="50"
                              height="20"
                              :fill="
                                'url(#' + props.item['pattern']['id'] + ')'
                              "
                            />
                          </g>
                        </svg>
                        <span class="black--text text-body-1 ma-0 pa-0 ml-2">
                          {{ props.item.label.replace(/^\[O\]_/, '') }}
                        </span>
                      </template>
                    </v-select>
                  </div>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0 mt-n6">
              <div class="ma-0 pa-0" style="display: flex;" align="center">
                <span class="pa-0 ma-2">Show:</span>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-checkbox
                        v-model="showTooltips"
                        class="my-checkbox pa-0 ma-0 mt-2"
                        label="tooltips"
                        dense
                        hide-details
                      ></v-checkbox>
                    </span>
                  </template>
                  <span v-if="true">Show tooltips</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-checkbox
                        v-model="showErrorBars"
                        class="my-checkbox pa-0 ma-0 pl-3 mt-2"
                        label="error bars"
                        dense
                        hide-details
                      ></v-checkbox>
                    </span>
                  </template>
                  <span v-if="true">Show error bars</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-checkbox
                        v-model="showOdds"
                        class="my-checkbox pa-0 ma-0 pl-3 mt-2"
                        label="odds ratio"
                        dense
                        hide-details
                      ></v-checkbox>
                    </span>
                  </template>
                  <span v-if="true">Show odds ratio with 95% CI</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-checkbox
                        v-model="showPVals"
                        class="my-checkbox pa-0 ma-0 pl-3 mt-2"
                        label="p-values"
                        dense
                        hide-details
                      ></v-checkbox>
                    </span>
                  </template>
                  <span v-if="true">Show p-values</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-checkbox
                        v-model="showLogScale"
                        class="my-checkbox pa-0 ma-0 pl-3 mt-2"
                        label="log scale"
                        dense
                        hide-details
                      ></v-checkbox>
                    </span>
                  </template>
                  <span v-if="true">Show log scale on x-axis</span>
                </v-tooltip>
              </div>
            </v-row>

            <v-row v-if="odds_ratio_error != null" class="ma-0 pa-0 my-3">
              <v-col cols="12">
                <v-icon color="warning" medium class="pb-1 pr-2"
                  >warning</v-icon
                >
                Regression analysis failed: {{ odds_ratio_error }}
              </v-col>
            </v-row>

            <v-row v-if="odds_ratio_error == null" class="ma-0 pa-0 mb-4">
              <v-col cols="12" class="pa-0 ma-0">
                <span
                  v-if="hasCategorical"
                  class="text-subtitle-1 ma-0 ml-2 pa-0"
                  >Asterisk (*) indicates reference category for categorical
                  variables.</span
                >

                <div v-if="odds_ratio_request_status == 'loading'">
                  <v-subheader class="title primary--text text--lighten-4">
                    <loading-spinner />
                  </v-subheader>
                </div>

                <PlotlyChart
                  v-if="odds_ratio_request_status == 'loaded'"
                  :data="chartData"
                  :layout="chartLayout"
                  class="ma-0 pa-0 mt-2"
                />
              </v-col>
            </v-row>

            <v-divider v-if="hasErrors" class="ml-4 mr-4"></v-divider>

            <v-row class="ma-0 pa-0">
              <v-expansion-panels
                v-if="odds_ratio_request_status == 'loaded' && hasErrors"
                accordion
                flat
              >
                <!-- Show Individual subject -->
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <span class="text-subtitle-1"
                      >Show regression analysis errors</span
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-data-table
                      ref="table"
                      :headers="headers"
                      :items="odds_ratio"
                      :must-sort="true"
                      dense
                      hide-default-footer
                      disable-pagination
                    >
                      <template v-slot:item="props">
                        <tr v-if="props.item.error">
                          <td class="text-subtitle-1 text-xs-left">
                            <v-tooltip top color="primary">
                              <template v-slot:activator="{ on: tooltip }">
                                <span v-on="{ ...tooltip }">
                                  {{ props.item.abbreviation }}
                                </span>
                              </template>
                              <span> {{ props.item.label }} </span>
                            </v-tooltip>
                          </td>
                          <td class="text-subtitle-1 text-xs-left">
                            <v-icon color="warning" medium class="pb-1"
                              >warning</v-icon
                            >
                            {{ props.item.error }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { state } from '@/store/modules/dataExplorer/types';
import { format } from 'd3-format';
import { colors } from '@/utils/colors';
import PlotlyChart from '@/components/common/PlotlyChart.vue';
import { missingDomainFallback } from '@/utils/helpers';

export default {
  components: {
    PlotlyChart,
  },
  filters: {
    formatPValue(pvalue) {
      if (pvalue == null) {
        return '-';
      }
      if (pvalue < 0.001) {
        return '< 0.001';
      } else {
        return format('.3f')(pvalue);
      }
    },
    formatPValueText(pvalue) {
      if (pvalue == null) {
        return '';
      }
      if (pvalue < 0.001) {
        return 'p < 0.001';
      } else {
        return 'p = ' + format('.3f')(pvalue);
      }
    },
    formatOddsText(odds, ll, ul) {
      return (
        format('.2f')(odds) +
        ' (' +
        format('.2f')(ll) +
        ', ' +
        format('.2f')(ul) +
        ')'
      );
    },
  },
  props: {
    showTitleBar: {
      type: Boolean,
      required: false,
      default: true,
    },
    showFullPanelView: {
      type: Boolean,
      required: false,
      default: false,
    },
    analysis: {
      type: Object,
      required: true,
      default: () => {},
    },
    visibleCohorts: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedAnalysisMode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pval_thresholds: [0.001, 0.01, 0.05, 0.1, 1],
      chartData: [],
      chartLayout: {},
      colors: colors,
      colorScheme: 'brewer5',
      odds_ratio: {},
      odds_ratio_error: null,
      odds_ratio_request_status: null,
      odds_ratio_control_cohort_id: null,
      odds_ratio_target_cohort_id: null,
      displayedItems: [],
      controlCohort: null,
      targetCohort: null,
      showTooltips: true,
      showErrorBars: true,
      showOdds: true,
      showPVals: false,
      showLogScale: false,
      hasErrors: false,
      hasCategorical: false,
      missingDomainFallback: missingDomainFallback,
    };
  },
  computed: {
    ...mapState('dataExplorer', {
      collection: state.COLLECTION,
      data: state.DATA,
    }),
    headers() {
      var headers = [
        {
          text: 'Variable',
          align: 'left',
          sortable: false,
          value: 'label',
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: 'Error',
          align: 'left',
          sortable: false,
          value: 'err',
          class: 'text-subtitle-1 font-weight-bold',
        },
      ];
      return headers;
    },
    variable() {
      return this.analysis.predictorVariables[0].observation_ontology;
    },
  },
  watch: {
    async visibleCohorts() {
      if (this.visibleCohorts.length < 2) {
        this.odds_ratio = {};
        this.odds_ratio_error = null;
        this.odds_ratio_request_status = null;
        this.controlCohort = null;
        this.targetCohort = null;
      } else {
        if (this.targetCohort == null && this.controlCohort == null) {
          this.targetCohort = this.visibleCohorts[0];
          this.controlCohort = this.visibleCohorts[1];
        }
      }
    },
    async targetCohort(newVal, oldVal) {
      if (
        newVal != null &&
        (oldVal == null || oldVal.id != newVal.id) &&
        this.controlCohort != null
      ) {
        if (newVal.id == this.controlCohort.id) {
          this.odds_ratio = {};
          this.odds_ratio_error = null;
          this.odds_ratio_request_status = null;
          this.controlCohort = null;
        } else if (this.targetCohort != null && this.controlCohort != null) {
          await this.analyze_cohorts();
        }
      } else {
        this.odds_ratio = {};
        this.odds_ratio_error = null;
        this.odds_ratio_request_status = null;
      }
    },
    async controlCohort(newVal, oldVal) {
      if (
        newVal != null &&
        (oldVal == null || oldVal.id != newVal.id) &&
        this.targetCohort != null
      ) {
        if (newVal.id == this.targetCohort.id) {
          this.odds_ratio = {};
          this.odds_ratio_error = null;
          this.odds_ratio_request_status = null;
          this.targetCohort = null;
        } else if (this.targetCohort != null && this.controlCohort != null) {
          await this.analyze_cohorts();
        }
      } else {
        this.odds_ratio = {};
        this.odds_ratio_error = null;
        this.odds_ratio_request_status = null;
      }
    },
    showTooltips() {
      this.renderForestPlot();
    },
    showErrorBars() {
      this.renderForestPlot();
    },
    showOdds() {
      this.renderForestPlot();
    },
    showPVals() {
      this.renderForestPlot();
    },
    showLogScale() {
      this.renderForestPlot();
    },
  },
  async mounted() {
    if (this.visibleCohorts.length >= 2) {
      this.targetCohort = this.visibleCohorts[0];
      this.controlCohort = this.visibleCohorts[1];
    }
  },
  methods: {
    unroll(odds_ratio) {
      const unrolled = [];
      odds_ratio.forEach(v => {
        if (v.data_category === 'Continuous') {
          unrolled.push({
            abbreviation: v.label,
            error: v.error,
            ll: v.ll,
            odds_ratio: v.odds_ratio,
            pval: v.pval,
            ul: v.ul,
          });
        } else if (v.data_category === 'Categorical') {
          if (!v.error) {
            for (const c in v.categories) {
              const d = v.categories[c];
              unrolled.push({
                abbreviation: d.label,
                error: d.error,
                ll: d.ll,
                odds_ratio: d.odds_ratio,
                pval: d.pval,
                ul: d.ul,
              });
            }
          } else {
            unrolled.push({
              abbreviation: v.label,
              error: v.error,
              ll: null,
              odds_ratio: null,
              pval: null,
              ul: null,
            });
          }
        }
      });

      return unrolled;
    },
    async analyze_cohorts() {
      let collection = this.collection;
      let cohorts = [this.targetCohort, this.controlCohort];
      // same analysis is already loading
      if (
        this.odds_ratio_request_status == 'loading' &&
        this.odds_ratio_target_cohort_id == cohorts[0].id &&
        this.odds_ratio_control_cohort_id == cohorts[1].id
      ) {
        return;
      }
      let analysis = this.analysis;
      let data = this.data;
      let comparisonField = this.analysis.input.comparisonField;
      // track current comparison
      this.odds_ratio_target_cohort_id = cohorts[0].id;
      this.odds_ratio_control_cohort_id = cohorts[1].id;
      this.odds_ratio_request_status = 'loading';

      // need cohorts, collection, and output vars
      if (
        typeof collection === 'undefined' ||
        typeof collection.observation_variables === 'undefined' ||
        typeof cohorts === 'undefined' ||
        typeof analysis == 'undefined' ||
        cohorts.length != 2
      ) {
        this.odds_ratio = {};
        this.odds_ratio_error = null;
        this.odds_ratio_request_status = null;
        return;
      }

      // create groups
      const groups = [];
      cohorts.forEach(c => {
        if (c.collection_id == collection.id) {
          const subjids = [];
          c.subject_ids.forEach(sid => {
            subjids[sid] = 1;
          });
          const cohortData = data.filter(d => d.subject_id in subjids);
          groups.push(cohortData);
        }
      });

      const outputVariables = this.analysis.outcomeVariables;

      try {
        const { data } = await axios.post(`/api/compute-multiple-regression`, {
          comparisonField: comparisonField,
          targetData: groups[0],
          sourceData: groups[1],
          outputVariables: outputVariables,
        });
        this.odds_ratio = this.unroll(data.results);
        this.odds_ratio_request_status = 'loaded';
        if (data.success) {
          this.odds_ratio_error = null;
        } else {
          this.odds_ratio_error = data.error;
        }
        this.renderForestPlot();
      } catch ({ response }) {
        // response.data.error
      }
    },
    renderForestPlot() {
      this.chartData = [];
      this.displayedItems = [];
      this.hasErrors = false;
      this.hasCategorical = false;
      var lineColor = this.pval_table_cell_color(0);

      for (var i = -1; i < this.pval_thresholds.length; ++i) {
        let x = [];
        let x_ll = [];
        let x_ul = [];
        let y = [];
        let text = [];
        let customdata = [];

        var color = null;

        if (i == -1) {
          color = 'black';

          for (const v of this.odds_ratio) {
            if (v.error == null && v.pval == null) {
              x.push(v.odds_ratio);
              x_ll.push(v.ll);
              x_ul.push(v.ul);
              y.push(v.abbreviation);
              this.displayedItems.push(v.abbreviation);
              text.push('');
              customdata.push({
                pval: this.$options.filters.formatPValue(v.pval),
                ll: v.ll,
                ul: v.ul,
              });
              this.hasCategorical = true;
            } else if (v.error != null) {
              this.hasErrors = true;
            }
          }
        } else {
          var ll = i == 0 ? -1e-6 : this.pval_thresholds[i - 1];
          var ul = this.pval_thresholds[i];
          color = this.pval_table_cell_color(ll);

          for (const v of this.odds_ratio) {
            if (
              v.error == null &&
              v.pval != null &&
              v.pval > ll &&
              v.pval <= ul
            ) {
              x.push(v.odds_ratio);
              x_ll.push(v.odds_ratio - v.ll);
              x_ul.push(v.ul - v.odds_ratio);
              y.push(v.abbreviation);
              this.displayedItems.push(v.abbreviation);

              if (this.showOdds && !this.showPVals) {
                text.push(
                  this.$options.filters.formatOddsText(v.odds_ratio, v.ll, v.ul)
                );
              } else if (!this.showOdds && this.showPVals) {
                text.push(this.$options.filters.formatPValueText(v.pval));
              } else if (this.showOdds && this.showPVals) {
                text.push(
                  this.$options.filters.formatOddsText(
                    v.odds_ratio,
                    v.ll,
                    v.ul
                  ) +
                    ', ' +
                    this.$options.filters.formatPValueText(v.pval)
                );
              }

              customdata.push({
                pval: this.$options.filters.formatPValueText(v.pval),
                ll: v.ll,
                ul: v.ul,
              });
            } else if (v.error != null) {
              this.hasErrors = true;
            }
          }
        }

        let chartData = {
          y: y,
          x: x,
          customdata: customdata,
          mode: 'markers+text',
          type: 'scatter',
        };

        if (i == -1) {
          chartData['marker'] = {
            size: 12,
            symbol: 'square',
            color: color,
          };
        } else {
          chartData['marker'] = {
            size: 12,
            color: color,
            line: {
              color: lineColor,
              width: 2,
            },
          };
        }

        if (this.showTooltips) {
          if (i == -1) {
            chartData['hovertemplate'] = 'Reference Category<extra></extra>';
          } else {
            chartData['hovertemplate'] =
              '%{x:.3f} (%{customdata.ll:.3f}, %{customdata.ul:.3f})<br>%{customdata.pval}<extra></extra>';
          }
        } else {
          chartData['hoverinfo'] = 'skip';
        }

        if (this.showErrorBars) {
          chartData['error_x'] = {
            type: 'data',
            symmetric: false,
            array: x_ul,
            arrayminus: x_ll,
            visible: true,
            color: lineColor,
            thickness: 2,
          };
        }

        if (this.showOdds || this.showPVals) {
          chartData['text'] = text;
          chartData['textposition'] = 'top center';
        }

        this.chartData.push(chartData);
      }

      // get order of variables to display in plot
      const sorter = (a, b) => {
        let [a_var, a_cat] = a.abbreviation.split(' | ');
        let [b_var, b_cat] = b.abbreviation.split(' | ');

        if (a_var > b_var) {
          return -1;
        } else if (a_var < b_var) {
          return 1;
        } else {
          let a_ref = a_cat.endsWith('*');
          a_cat = a_cat.replace(' *', '');

          let b_ref = b_cat.endsWith('*');
          b_cat = b_cat.replace(' *', '');

          if (a_ref && !b_ref) {
            return 1;
          } else if (!a_ref && b_ref) {
            return -1;
          } else {
            if (a_cat > b_cat) {
              return -1;
            } else {
              return 1;
            }
          }
        }
      };
      this.odds_ratio.sort(sorter);

      var order = this.odds_ratio
        .map(a => a.abbreviation)
        .filter(a => this.displayedItems.includes(a));

      var numDisplayed = this.displayedItems.length;
      var rowHeight = numDisplayed > 1 ? 50 : 80;
      this.chartLayout = {
        showlegend: false,
        responsive: true,
        autosize: true,
        height: rowHeight * numDisplayed + 80,
        shapes: [
          {
            type: 'line',
            x0: 1,
            y0: -0.5,
            x1: 1,
            y1: numDisplayed,
            line: {
              color: 'rgba(0,0,0,0.4)',
              width: 2,
              dash: 'dash',
            },
            layer: 'between',
          },
        ],
        margin: {
          t: 0,
          r: 40,
          b: 100,
        },
        yaxis: {
          zeroline: false,
          automargin: true,
          range: [-0.5, numDisplayed],
          fixedrange: true,
          categoryorder: 'array',
          categoryarray: order,
        },
        xaxis: {
          zeroline: false,
          automargin: true,
          title: 'Odds Ratio',
          fixedrange: false,
        },
        hoverlabel: {
          bgcolor: '#ffffff',
          margin: {
            l: 10,
          },
          font: {
            family: 'Roboto, sans-serif',
            size: 16,
          },
        },
        font: {
          family: 'Roboto, sans-serif',
          size: 16,
        },
        modebar: {
          remove: ['lasso', 'select'],
        },
        annotations: [
          {
            xref: 'paper',
            yref: 'paper',
            x: 1,
            xanchor: 'right',
            y: 0,
            yanchor: 'center',
            yshift: -50,
            xshift: 0,
            ay: 0,
            ax: -20,
            arrowhead: 2,
            text: 'Increasing likelihood<br>of being in target<br> study group',
            showarrow: true,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 0,
            xanchor: 'left',
            y: 0,
            yanchor: 'center',
            yshift: -50,
            xshift: 0,
            ay: 0,
            ax: 20,
            arrowhead: 2,
            text:
              'Increasing likelihood<br>of being in control<br> study group',
            showarrow: true,
          },
        ],
      };

      if (this.showLogScale) {
        this.chartLayout['xaxis']['type'] = 'log';
      }
    },
    getPvalColor(pv) {
      var c = colors['pvals'][pv.toString() + '-' + this.colorScheme];
      if (c) {
        return c['color'];
      } else {
        return 'white';
      }
    },
    pval_table_cell_aux(pval, which) {
      let ccl = this.colors['pvals']['1' + '-' + this.colorScheme][which];
      if (pval == null) {
        return ccl;
      } else {
        if (pval < 0.001) {
          ccl = this.colors['pvals']['0.001' + '-' + this.colorScheme][which];
        } else if (pval < 0.01) {
          ccl = this.colors['pvals']['0.01' + '-' + this.colorScheme][which];
        } else if (pval < 0.05) {
          ccl = this.colors['pvals']['0.05' + '-' + this.colorScheme][which];
        } else if (pval < 0.1) {
          ccl = this.colors['pvals']['0.1' + '-' + this.colorScheme][which];
        }
        return ccl;
      }
    },
    pval_table_cell_class(pval) {
      return this.pval_table_cell_aux(pval, 'class');
    },
    pval_table_cell_color(pval) {
      return this.pval_table_cell_aux(pval, 'color');
    },
    pval_table_text_color(pval) {
      if (this.colorScheme == 'brewer5') {
        if (pval != null && pval < 0.001) {
          return 'white';
        }
      }
      return 'black';
    },
  },
};
</script>

<style>
.isFullSizeViewWidth {
  width: fit-content;
}

.isFullSizeViewOverflow {
  overflow: auto;
}

.my-checkbox {
  display: inline-block;
}
</style>
